import { Footer } from "antd/lib/layout/layout";
import styled from "styled-components";

const FooterStyles = styled(Footer)`
  background: white;
  color: white;
  font-size: 18px;
`;

export default FooterStyles;
